import { PersonData, ModalVariant, WINNERS, ADVISORY } from './modal-data';

function buildModal(data: PersonData, variant: ModalVariant): HTMLElement {
  const overlay = document.createElement('div');
  overlay.className = 'p-modal-overlay';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', `${data.name}のプロフィール`);

  overlay.innerHTML = `
    <div class="p-modal p-modal--${variant}">
      <div class="p-modal__bg" aria-hidden="true">
        <img src="./assets/${variant}/bg-overlay.webp" alt="" class="p-modal__bg-img">
      </div>
<p class="p-modal__ghost" aria-hidden="true">${variant}</p>
      <button class="p-modal__close" type="button" aria-label="閉じる">
        <img src="./assets/modal/close.svg" alt="" class="p-modal__close-icon">
      </button>
      <div class="p-modal__deco" aria-hidden="true">
        <div class="p-modal__deco-v-main">
          <span></span><span></span><span></span>
        </div>
        <div class="p-modal__deco-h-main">
          <span></span><span></span><span></span>
        </div>
        <div class="p-modal__deco-v-corner">
          <span></span><span></span><span></span>
        </div>
        <div class="p-modal__deco-v-inner">
          <span></span><span></span><span></span>
        </div>
      </div>
      <div class="p-modal__content">
        <div class="p-modal__photo">
          <img src="${data.photoModal ?? data.photo}" alt="${data.name}" class="p-modal__photo-img">
        </div>
        <div class="p-modal__body">
          <div class="p-modal__info">
            <p class="p-modal__name">${data.name}</p>
            ${data.role ? `<p class="p-modal__role">${data.role}</p>` : ''}
          </div>
          <div class="p-modal__bio-wrap">
            <p class="p-modal__bio">${data.bio}</p>
          </div>
        </div>
      </div>
    </div>
  `;

  return overlay;
}

function closeModal(): void {
  const overlay = document.querySelector<HTMLElement>('.p-modal-overlay');
  if (!overlay) return;

  overlay.classList.remove('is-open');
  document.body.classList.remove('modal-open');

  overlay.addEventListener('transitionend', () => overlay.remove(), { once: true });
}

function openModal(variant: ModalVariant, personId: number): void {
  if (document.querySelector('.p-modal-overlay')) return;

  const list = variant === 'winners' ? WINNERS : ADVISORY;
  const data = list.find((p) => p.id === personId) ?? list[0];

  const overlay = buildModal(data, variant);
  document.body.appendChild(overlay);
  document.body.classList.add('modal-open');

  // Esc キーで閉じる
  const onKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      closeModal();
      document.removeEventListener('keydown', onKeydown);
    }
  };
  document.addEventListener('keydown', onKeydown);

  // 閉じるボタン
  overlay.querySelector('.p-modal__close')?.addEventListener('click', () => {
    closeModal();
    document.removeEventListener('keydown', onKeydown);
  });

  // オーバーレイ背景クリックで閉じる
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      closeModal();
      document.removeEventListener('keydown', onKeydown);
    }
  });

  // アニメーション開始
  requestAnimationFrame(() => {
    requestAnimationFrame(() => overlay.classList.add('is-open'));
  });
}

export function initModal(): void {
  document.addEventListener('click', (e) => {
    const trigger = (e.target as Element).closest<HTMLElement>('.js-modal-trigger');
    if (!trigger) return;

    const variant = trigger.dataset.variant as ModalVariant | undefined;
    if (variant !== 'winners' && variant !== 'advisory') return;

    const personId = parseInt(trigger.dataset.personId ?? '0', 10);
    openModal(variant, personId);
  });
}
